module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/hero-integration-30a64bcc72e95adf0649b1a4c8cc6c40.svg";